import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigPdvDeliveryResponse, ConfigPedidoResponse, ConfigPedidoViewModel, ConfiguracaoPedido } from '../../models/configuracao.model';

@Component({
    selector: 'app-configuracao-pedido-dialog',
    templateUrl: './configuracao-pedido-dialog.component.html',
    styleUrls: ['./configuracao-pedido-dialog.component.scss'],
})
export class ConfiguracaoPedidoDialogComponent implements OnInit {
    public panelOpenState: boolean = false;
    public configIntegracao: ConfigPedidoResponse = new ConfigPedidoResponse();

    constructor(
        public dialogRef: MatDialogRef<ConfiguracaoPedidoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfigPdvDeliveryResponse,
    ) { }

    ngOnInit() {
        this.configIntegracao = this.data.configIntegracao[0];
    }

    public formatarHora(event: any) {
        let valor = event.target.value.replace(/\D/g, '');

        if (valor.length > 4) {
            valor = valor.substring(0, 4);
        }

        let horas = valor.substring(0, 2);
        let minutos = valor.substring(2, 4);

        let formatado = horas;
        if (valor.length >= 3) formatado += ":" + minutos;

        const h = parseInt(horas, 10);
        const m = parseInt(minutos || "0", 10);

        if (h > 24) {
            horas = "24";
            minutos = "00";
            formatado = "24:00";
        } else if (h === 24 && m > 0) {
            minutos = "00";
            formatado = "24:00";
        }

        if (m > 59) {
            minutos = "59";
            const horaFormatada = h < 10 ? `0${h}` : h;
            formatado = `${horaFormatada}:59`;
        }

        event.target.value = formatado.substring(0, 5);
    }


    public atualizarIntegracao() {
        this.data.configIntegracao[0] = this.configIntegracao;
    }

    public permitirSomenteNumeros(event: KeyboardEvent) {
        const permitido = /[0-9]|Backspace|Tab|ArrowLeft|ArrowRight|Delete|:/;
        if (!permitido.test(event.key)) {
            event.preventDefault();
        }
    }
}
